module.exports = __webpack_public_path__ + "img/activemath.f7b62057.png";